
const periods = [
    {
        "year": 0,
        "month": 1,
        "id": "3a1d9965-9253-43a1-a38b-0a793f8e6152"
    },
    {
        "year": 0,
        "month": 2,
        "id": "c97eaac5-7283-4414-a3d9-ef46d68ee526"
    },
    {
        "year": 1,
        "month": 1,
        "id": "e774b0f1-c36e-40f9-9855-fda7d5f386fc"
    },
    {
        "year": 1,
        "month": 2,
        "id": "0cad2d9b-4c5d-42b5-b2a8-35c4c34cbc06"
    },
    {
        "year": 1,
        "month": 3,
        "id": "32ad728e-8a43-4e40-8edc-dd5519f3e8e7"
    },
    {
        "year": 1,
        "month": 4,
        "id": "9acc91c0-bd98-4b40-8f49-3413dacd92f2"
    },
    {
        "year": 1,
        "month": 5,
        "id": "60b5e2b6-7aec-4bf8-8c53-b7985899aa25"
    },
    {
        "year": 1,
        "month": 6,
        "id": "ddef4936-ba5a-45bc-adcd-c2019d67cbc4"
    },
    {
        "year": 1,
        "month": 7,
        "id": "53728bbe-e023-4d40-b3e5-69ab2055829a"
    },
    {
        "year": 1,
        "month": 8,
        "id": "5966ee89-5cb4-4953-abd9-082f5a6a40af"
    },
    {
        "year": 1,
        "month": 9,
        "id": "bacdcdee-4211-460c-9349-d5997add9cdc"
    },
    {
        "year": 1,
        "month": 10,
        "id": "8db31326-d0c0-4798-a7d4-f46ebe641812"
    },
    {
        "year": 1,
        "month": 11,
        "id": "1253fad1-f574-44fb-b9c1-87d41e95d463"
    },
    {
        "year": 1,
        "month": 12,
        "id": "cc038054-6a9e-4619-9e4e-12c62de99192"
    },
    {
        "year": 2,
        "month": 11,
        "id": "b7908dd4-c803-41fd-b671-c0b0e2a51258"
    },
    {
        "year": 2,
        "month": 12,
        "id": "80af3f04-1f19-4c20-ad80-e5c340873cb9"
    }
];

export default { periods };
